import { LOCALE_KEYS } from "@foodlista/shared/i18n/constants"
import { z } from "zod"

export const translateProductsInputSchema = z.object({
	sourceLocale: z
		.enum(LOCALE_KEYS)
		.describe("The detected language of the extracted products"),
	products: z
		.array(
			z.object({
				productId: z.string().uuid(),
				name: z.string(),
				description: z.string().optional(),
			}),
		)
		.min(1),
})

export const translateProductsOutputSchema = z.object({
	results: z.array(
		z.object({
			productId: z.string().uuid(),
			status: z.enum(["applied", "skipped"]),
		}),
	),
})

/**
 * Semantic phases emitted by the translate-products task via `ctx.progress`.
 * Frontend maps `kind` → translation key; the backend does not know locale
 * or namespaces.
 */
export type TranslateProductsProgressPhase =
	| { kind: "translating"; count: number }
	| { kind: "done" }

export type TranslateProductsInput = z.infer<
	typeof translateProductsInputSchema
>
export type TranslateProductsOutput = z.infer<
	typeof translateProductsOutputSchema
>
